var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.29954 2.3667C2.78388 2.3667 2.36621 2.78437 2.36621 3.30003V11.7C2.36621 12.2157 2.78388 12.6334 3.29954 12.6334H11.6995C12.2152 12.6334 12.6329 12.2157 12.6329 11.7V3.30003C12.6329 2.78437 12.2152 2.3667 11.6995 2.3667H3.29954ZM4.53548 4.70003H6.68744L7.94342 6.49561L9.49746 4.70003H10.1747L8.24785 6.93128L10.6049 10.3H8.45293L7.05931 8.30758L5.33848 10.3H4.65033L6.75306 7.871L4.53548 4.70003ZM5.57637 5.25238L8.72819 9.74495H9.56309L6.41035 5.25238H5.57637Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.9ba5268f38eb45fd7b54a716eb52a530.svg";
export { ForwardRef as ReactComponent };